import ComingSoon from './ComingSoon';
import { Activity } from 'lucide-react';

const SystemHealthPanel = () => {
  return (
    <div className="space-y-6">
      <ComingSoon
        title="System Health"
        description="Real-time system health monitoring, service status, and performance metrics will be available soon."
        icon={<Activity className="h-8 w-8 text-blue-600" />}
      />
    </div>
  );
};

export default SystemHealthPanel;
